import React, { useState } from 'react';
import { Input, Button, Toast } from '@douyinfe/semi-ui';
import { API } from '../helpers';
import { navigate } from '../router';

const AdminLogin = () => {
  const [username, setUsername] = useState('admin');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!username || !password) {
      Toast.warning('请输入管理员账号和密码');
      return;
    }
    setLoading(true);
    try {
      const r = await API.post('/api/admin/login', { username, password });
      if (r.data.success) {
        Toast.success('登录成功');
        navigate('/admin/stats');
      } else {
        Toast.error(r.data.message || '登录失败');
      }
    } catch (e) {
      Toast.error(e.response?.data?.message || '网络错误');
    } finally {
      setLoading(false);
    }
  };

  const labelStyle = { fontSize: 13, color: '#4e5969', marginBottom: 4, display: 'block' };
  const fieldStyle = { marginBottom: 12 };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#f7f8fa',
    }}>
      <div style={{
        background: '#fff',
        padding: '32px',
        borderRadius: 10,
        width: 360,
        boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
      }}>
        <h2 style={{ margin: '0 0 20px', textAlign: 'center', fontSize: 18 }}>管理员登录</h2>

        <div style={fieldStyle}>
          <label style={labelStyle}>管理员账号</label>
          <Input
            value={username}
            onChange={setUsername}
            placeholder="admin"
          />
        </div>
        <div style={fieldStyle}>
          <label style={labelStyle}>密码</label>
          <Input
            type="password"
            value={password}
            onChange={setPassword}
            placeholder="请输入密码"
            onKeyDown={(e) => e.key === 'Enter' && handleSubmit()}
          />
        </div>

        <Button
          type="primary"
          theme="solid"
          loading={loading}
          onClick={handleSubmit}
          block
          style={{ marginTop: 16 }}
        >
          登录
        </Button>
        <div style={{ marginTop: 12, fontSize: 12, color: '#86909c', textAlign: 'center' }}>
          <a
            href="/"
            onClick={(e) => { e.preventDefault(); navigate('/'); }}
            style={{ color: '#86909c', textDecoration: 'none' }}
          >
            返回用户面板
          </a>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
